import { useEffect, useState } from "react";
import { UserCog, LogOut } from "lucide-react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const useMinutesLeft = (expiresAt) => {
  const [left, setLeft] = useState(null);
  useEffect(() => {
    if (!expiresAt) return;
    const tick = () => {
      const ms = new Date(expiresAt) - Date.now();
      if (ms <= 0) window.location.reload();
      setLeft(Math.max(0, Math.ceil(ms / 60000)));
    };
    tick();
    const t = setInterval(tick, 15000);
    return () => clearInterval(t);
  }, [expiresAt]);
  return left;
};

const Bar = ({ testId, label, left, action, onAction }) => (
  <div data-testid={testId} className="sticky top-0 z-[60] bg-amber-400 text-amber-950 px-4 py-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-sm font-medium shadow-lg">
    <UserCog className="h-4 w-4" />
    <span data-testid={`${testId}-label`}>{label}</span>
    <span className="num text-xs opacity-80" data-testid={`${testId}-timer`}>ends in {left ?? "–"} min</span>
    <Button data-testid={`${testId}-return`} size="sm" onClick={onAction} className="h-7 rounded-full bg-amber-950 text-amber-100 hover:bg-amber-900"><LogOut className="h-3.5 w-3.5 mr-1" />{action}</Button>
  </div>
);

export const StaffImpersonationBanner = () => {
  const { user } = useAuth();
  const left = useMinutesLeft(user?.impersonator?.expires_at);
  if (!user?.impersonator) return null;
  const stop = async () => { await api.post("/auth/stop-impersonating").catch(() => {}); window.location.href = "/settings"; };
  return <Bar testId="imp-banner" left={left} label={`Viewing as ${user.name} (${user.email}). Signed in as ${user.impersonator.name}. Payments and admin tools are disabled.`} action="Return to my account" onAction={stop} />;
};

export const PortalImpersonationBanner = () => {
  const { pathname } = useLocation();
  const [imp, setImp] = useState(null);
  useEffect(() => { api.get("/portal/me").then((r) => setImp(r.data.impersonator ? r.data : null)).catch(() => setImp(null)); }, [pathname]);
  const left = useMinutesLeft(imp?.impersonator?.expires_at);
  if (!imp) return null;
  const end = async () => { await api.post("/portal/logout").catch(() => {}); window.close(); window.location.href = "/clients"; };
  return <Bar testId="portal-imp-banner" left={left} label={`Viewing the portal as ${imp.name}. Opened by ${imp.impersonator.name}. Payments and password changes are disabled.`} action="End client view" onAction={end} />;
};
